import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function VideoEditing() {
  return (
    <>
      <SEO title="Video Editing Services" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div
          className="slider-area slider-style-1 height-380 bg_image"
          data-black-overlay="1"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/video-edit-banner.png)`
          }}
        ></div>

        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div
              style={{
                height: '8px',
                width: '60px',
                background: '#00C896',
                marginBottom: '2rem'
              }}
            ></div>
            <h1>Professional Video Editing</h1>
            <p style={{ marginBottom: '3.5rem' }}>TOP VIDEO EDITING AGENCY IN INDIA</p>
            <p style={{ marginBottom: '3.5rem' }}>
              Want to turn raw footage into a masterpiece? Looking to boost engagement with eye-catching edits?
              Our expert video editing services help bring your vision to life—polished, professional, and
              ready for any platform.
            </p>
            <h3>Creative Visual Storytelling</h3>
            <p style={{ marginBottom: '3.5rem' }}>
              Whether it's YouTube content, promotional videos, or cinematic reels—we handle every frame with
              precision and creativity. Our editing team works with industry-leading tools like Adobe Premiere Pro,
              DaVinci Resolve, and After Effects to ensure high-quality output that aligns with your brand voice.
            </p>

            <h3>What We Deliver:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Polished Cuts and Transitions</li>
              <li>Color Grading & Audio Syncing</li>
              <li>Motion Graphics & Subtitles</li>
              <li>Content Optimized for YouTube, Instagram, Reels, Ads</li>
            </ul>

            <h3>Why Choose Our Video Editing Services?</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>85% of users are more likely to buy after watching a branded video.</li>
              <li>Video increases organic traffic from search engines by 157%.</li>
              <li>Reels and shorts are now dominating content algorithms—get ahead.</li>
              <li>High-quality videos build trust and brand identity.</li>
              <li>Engaging video content increases conversion by 80% or more.</li>
            </ul>

            <h3>Five Core Elements of Our Editing Workflow</h3>
            <p style={{ marginBottom: '3.5rem' }}>
              Every video is crafted through a clear and strategic process, ensuring quality and viewer impact.
            </p>

            <h4>1. Understanding Your Message</h4>
            <p style={{ marginBottom: '3.5rem' }}>
              We begin by identifying your video’s purpose, tone, and core message to ensure clarity in storytelling.
            </p>

            <h4>2. Knowing Your Audience</h4>
            <p style={{ marginBottom: '3.5rem' }}>
              From Gen Z social media trends to corporate branding—our edits adapt to your target demographic.
            </p>

            <h4>3. Platform Optimization</h4>
            <p style={{ marginBottom: '3.5rem' }}>
              We tailor your videos to fit the specific platform requirements—ratios, lengths, intros, and calls to action.
            </p>

            <h4>4. Visual Impact & Sound Design</h4>
            <p style={{ marginBottom: '3.5rem' }}>
              Music, transitions, graphics, and sound design are engineered to hold viewer attention and build emotion.
            </p>

            <h4>5. Feedback and Revisions</h4>
            <p style={{ marginBottom: '3.5rem' }}>
              We provide draft previews and work on revisions until your video feels just right—your satisfaction comes first.
            </p>

            <h3>Why Video Content is Non-Negotiable Today</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Video content has 1200% more shares than text and images combined.</li>
              <li>Businesses using video grow revenue 49% faster than non-video users.</li>
              <li>Short-form video boosts engagement, retention, and trust.</li>
              <li>Great editing gives your brand a professional edge.</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>
              Want your content to stand out? Let’s edit something amazing together.
            </p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/video-edit-thumb.png`} alt="Video Editing Service" />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default VideoEditing
